export default __webpack_public_path__ + "static/media/marketplace-icon.1a72f263.svg";